/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteContact (id: number) {
  return rest.delete(`/api/contacts/${id}`)
}

export function fetchContact (id: number): Promise<Contact> {
  return rest.get(`/api/contacts/${id}`)
    .then((resp) => resp.json())
}

export function findManyContacts (params?: Record<string, any>): Promise<HalDocument<{
  contacts: Contact[]
}>> {
  return rest.get(`/api/contacts?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchContact (id: number, data: Partial<Contact>) {
  return rest.patch(`/api/contacts/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postContact (data: Partial<Contact>) {
  return rest.post('/api/contacts', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
